import { render } from "./ChangeMemberInfoPage.vue?vue&type=template&id=72975fa1&scoped=true"
import script from "./ChangeMemberInfoPage.vue?vue&type=script&lang=js"
export * from "./ChangeMemberInfoPage.vue?vue&type=script&lang=js"

import "./ChangeMemberInfoPage.vue?vue&type=style&index=0&id=72975fa1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72975fa1"]])

export default __exports__